import { SchemaType, DOMType } from '../constants.js';
import { ensureArray } from './array.js';
export function getSchemaType(domType) {
    switch (domType) {
        case DOMType.NODE:
        case DOMType.BLOCK:
        case DOMType.INLINE_BLOCK: {
            return SchemaType.NODE;
        }
        default: {
            return SchemaType.MARK;
        }
    }
}
export function getSchemaTypeNameByName(name, schema) {
    if (schema.nodes[name]) {
        return 'node';
    }
    if (schema.marks[name]) {
        return 'mark';
    }
    return null;
}
export function belongsTo(input, nameOrGroups) {
    const type = 'type' in input ? input.type : input;
    return ensureArray(nameOrGroups).some((name) => { var _a; return name === type.name || ((_a = type.spec.group) === null || _a === void 0 ? void 0 : _a.split(' ').some((g) => g === name)); });
}
//# sourceMappingURL=schema-type.js.map